var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"roles-admin-page"}},[_c('div',{staticClass:"text-center"},[_c('p',{staticClass:"mt-1 text-sm text-gray-500"},[_vm._v("Access Levels has moved.")]),_c('div',{staticClass:"mt-5"},[_c('a',{staticClass:"button",attrs:{"type":"primary","href":_vm.href,"target":"_blank"}},[_vm._v("Access Levels")])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }